import Vue from 'vue'
import Router from 'vue-router'
// import home from '@/views/home'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'home',
    component: () => import('@/views/home')

    // components: {
    //   default: home
    // }
  }, {
    path: '/learning',
    name: 'learning',
    component: () => import('@/views/learning')
  }, {
    path: '/community',
    name: 'community',
    component: () => import('@/views/community')
  }, {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/blog')
  }, {
    path: '/aboutus',
    name: 'aboutUsF',
    component: () => import('@/views/aboutUs')
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js